// SET_PROJECT 
export const setProjects = (projects) => ({
  type:'SET_PROJECTS',
  projects
});


// WEBPACK FOOTER //
// ./src/actions/projects.js